import React from 'react';
import MarkdownLayout from '../../Layout/MarkdownLayout';

const PrivacyPolicyContainer = () => {
    return <MarkdownLayout title={'Privacy Policy'} mdFileName={'PrivacyPolicy'} />;
};

export default PrivacyPolicyContainer;
